<template>
    <div id="main-container">
        <page-header></page-header>
        <!--<transition name="fade">-->
            <router-view></router-view>
        <!--</transition>-->
    </div>
</template>

<script>
    import PageHeader from "../partials/Header.vue";

    export default {
        components: {
            PageHeader
        }
    }
</script>


// WEBPACK FOOTER //
// Main.vue?035d49a4